import React, {useContext} from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import usePortfolioContent from "../../hooks/usePortfolioContent";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);
  const {workExperiences} = usePortfolioContent();
  if (workExperiences.display) {
    return (
      <section id="experience" aria-label="Experience">
        <Fade bottom duration={1000} distance="20px">
          <div className="experience-container" id="workExperience">
            <div>
              <h2 className="experience-heading">Experiences</h2>
              <div className="experience-cards-div">
                {workExperiences.experience.map((card, i) => {
                  return (
                    <ExperienceCard
                      key={i}
                      isDark={isDark}
                      cardInfo={{
                        company: card.company,
                        desc: card.desc,
                        date: card.date,
                        companylogo: card.companylogo,
                        role: card.role,
                        descBullets: card.descBullets
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
  return null;
}
